/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name icon-new
 * @description Displays the New icon, this is pulled from the MUI icon we use in React.
 */
angular.module('mercury.directives.icon-new', [])
.directive('iconNew', function() {
    return {
      restrict: 'E',
      template: '<svg class="svg-icon-root" focusable="false" viewBox="0 0 24 24" fill="none !important">' +
        '<g transform="scale(0.85, 0.85) translate(2.1, 2.28)">' +
           '<path d="M2.704 14.5V8.836H3.552L6.832 13.54H6.848V8.836H7.52V14.5H6.672L3.392 9.796H3.376V14.5H2.704ZM9.3906 14.5V8.836H12.9506V9.46H10.0626V11.236H12.7586V11.86H10.0626V13.876H13.0946V14.5H9.3906ZM15.5928 14.5L13.9368 8.836H14.6808L15.9688 13.54H15.9848L17.3768 8.836H18.1288L19.5128 13.54H19.5288L20.8408 8.836H21.5448L19.8808 14.5H19.1528L17.7528 9.7H17.7368L16.3288 14.5H15.5928Z" fill="currentColor" />' +
        '</g>' +
        '<rect x="0.5" y="6" width="23" height="12" rx="2.5" stroke="currentColor" />' +
      '</svg>'
    }
  })